import { GetPartnerDashboardResponse } from '@/api/type/types';
import { Images } from '@/assets';
import { fonts } from '@/theme/fonts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface DashBoardWhatsUpProps {
  data: GetPartnerDashboardResponse;
}
const DashBoardWhatsUp = ({ data }: DashBoardWhatsUpProps) => {
  const { i18n, t } = useTranslation();

  const formatted = useMemo(() => {
    const now = new Date();
    if (i18n.language === 'ko') {
      return `${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일`;
    } else {
      return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
    }
  }, [i18n.language]);

  const EN = i18n.language === 'en';
  return (
    <Section>
      <Title>What's Up</Title>
      <WhatsUpList>
        <ListItem>
          <ListTitle>
            <Img
              src={Images.DashboardCalendarIcon}
              alt="main-date"
              $size="30px"
              $right={EN ? '12px' : '15px'}
            />
            <div>{formatted}</div>
          </ListTitle>
        </ListItem>
        <ListItem data-en={EN}>
          <ListTitle>
            <Img
              src={Images.DashboardHeartIcon}
              alt={`my-player-img`}
              $size="30px"
              $right={EN ? '13px' : '16px'}
            />
            <div>{t('myPlayer')}</div>
          </ListTitle>
          <Count>{data.myPlayers}</Count>
        </ListItem>
        <ListItem data-en={EN}>
          <ListTitle>
            <Img
              src={Images.DashboardStarIcon}
              alt={`my-star-img`}
              $size="35px"
              $right={EN ? '7px' : '10px'}
            />
            <div>{t('myReviews')}</div>
          </ListTitle>
          <Count>{data.receivedStars}</Count>
        </ListItem>
        <ListItem data-en={EN}>
          <ListTitle>
            <Img
              src={Images.DashboardOrderIcon}
              alt={`my-order-img`}
              $size="30px"
              $right={EN ? '12px' : '15px'}
            />
            <div>{t('ReceivedOrders')}</div>
          </ListTitle>
          <Count>{data.receivedOrders}</Count>
        </ListItem>
      </WhatsUpList>
    </Section>
  );
};

export default DashBoardWhatsUp;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Title = styled.div`
  width: 223px;
  height: 52px;
  border-radius: 60.5px;
  box-sizing: border-box;
  font-weight: ${fonts.weight.bold};
  font-size: 20px;
  line-height: normal;
  color: #fafbff;
  background: #b974ff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const WhatsUpList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 51px;
  width: 223px;
  padding: 0 32px 0 24px;
  box-sizing: border-box;
  border-radius: 30px;
  background: #6a96f8;
  font-weight: ${fonts.weight.bold};
  color: #fffdfd;
  &[data-en='true'] {
    padding: 0 27px 0 24px;
  }
`;

const ListTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: normal;
  white-space: nowrap;
`;

interface ImgProps {
  $size: string;
  $right: string;
}

const Img = styled.img<ImgProps>`
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  margin-right: ${({ $right }) => $right};
`;

const Count = styled.div`
  font-size: 20px;
`;
